export default "__VITE_ASSET__ByZwcBRa__"